/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

import '@wwdev/bootstrap/index.js';
import '@fancyapps/fancybox';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import './wwdev/lazysizes/index.js';

import 'select2';
import './vendor/viewport-class-on-resize'
import './wwdev/components/maps'
import './sections/highlight_projects'
import './sections/form_dealers';
import './components/become-dealer-fixed';
import './wwdev/default'
import './wwdev/webshop/index.js';
import './modules/maps.js';
import './modules/configurator';
import './components/product';
import './components/select2';
import Header from './base/header';
new Header();
import '@wwdev/search';
import './externals/datepicker'
import './wwdev/zipcode/index.js';

// Sunrooms
import './externals/@sunrooms/webshop';
import '@sunrooms/myaccount';



